import { BackendRoute } from '../../config/index';
import { ApiService } from '../../services/index';
import { AcceptedDataRoomInvite } from './space.types';

/**
 * Accepting happens on the way through authentication rather than on a page of its own, so it is
 * a plain call: there is no component whose lifecycle a mutation could hang from.
 */
export const acceptDataRoomInvite = (token: string): Promise<AcceptedDataRoomInvite> =>
  ApiService.post<AcceptedDataRoomInvite>({
    endpoint: BackendRoute.DATA_ROOM_INVITES,
    routePath: [token, 'accept'],
  });
